import CryptoJS from "crypto-js"
import { key } from "../Constants"

export const encryption = (data) => {

    const encryptedPassword = CryptoJS.AES.encrypt(
      data, key
    ).toString()

    return encryptedPassword
}




// WEBPACK FOOTER //
// ./src/app/common/encryption.js